
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as helprn3z3SpRcbkEAea_bnNqdzazSWHgF26M3jil37Eh8BsMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/help.vue?macro=true";
import { default as indexiDxrfDBubh7S_CpvTSv_Y84REN5A_45wqyGsum5CQFN0YMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/index.vue?macro=true";
import { default as loginAIueSh5IVgGjB_g2VXbod12bYbcJVZEjiHkT9xD6VXAMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/login.vue?macro=true";
import { default as logoutCxtyylqAG68mGzmya_Hs7uqCg_45PRQxPE5QPd40LJzZoMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/logout.vue?macro=true";
import { default as privacyTOJW22v_5ckQtznJLBmTx1ZSB_45kZYrrgZ2bqFtd_45EIEMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/privacy.vue?macro=true";
import { default as new_1MHALVTqL4MR8IJllkPo1be8PFbbpK71E3NQ0hC6eoMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/rie/new.vue?macro=true";
import { default as indexpqhPHYw13Qj8keZprWFTK96uU8Y_45WHcd_xWcUW5eiJkMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/rie/index.vue?macro=true";
import { default as editxpcnwLkUnrjIB_qPHoUbj42L7VA47s4r5rTGOhbaFA8Meta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/rie/[rieId]/edit.vue?macro=true";
import { default as indexTBPTr_45COJXGrMABxml82r2v74P7J_45S_JZ53T82EvLrQMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/rie/[rieId]/index.vue?macro=true";
import { default as rie4ecEzs_45HKgNoZM3k_451Y13BG4lPqJIfs9O1LPveTAYTAMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/rie.vue?macro=true";
import { default as indexw_45Yg1LKlVKTsORS6wtkFcl0U__xgcdceGxGb1Dndi34Meta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/index.vue?macro=true";
import { default as indexIF_3MAnwThpGfvfrBmnjR0kzFIDCHR71AqHPNOQ68ZYMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/risicos/index.vue?macro=true";
import { default as edit_YocqPlLHxcOg_45GjKoYdXs5fls95ci53_45GB0jo_45rkKIMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/edit.vue?macro=true";
import { default as indexzVaHB_6SAxC5KLYI3eRoiCihoQmSbHb6THh_75kKTJcMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/index.vue?macro=true";
import { default as risicosEL_457zOr6xPCdoXM7veXqN5euWpjJiHGlIBCBHyAbwyAMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/risicos.vue?macro=true";
import { default as dashboardFCyYS_35qbCGzHN7cDMpKUd8qIxS8lLucXuOPLn5UskMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/dashboard.vue?macro=true";
import { default as indexqthD6h0GP4_l6efjzQwoRUsGm9rwoKsyHr63jmwwedoMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/rapportage/index.vue?macro=true";
import { default as aanmakenHnhnxkUUcPpcWwOv0svE4rS4FlHVuCFopaVA6qROniMMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/rapportage/aanmaken.vue?macro=true";
import { default as rapportageahH2Ara1Tx14TxcHn45aWWI71RlCrDhqKECr4tMJvhUMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/rapportage.vue?macro=true";
import { default as indexWow1en__p_45m7P9tjivX3Rtds_45YtU_L2_qYV94HsyLqwMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/inventarisatie/index.vue?macro=true";
import { default as onderwerpen_yMvRRUt9T8YLohPuWRmcvCOcSIsnWAg3gll0HgeAXUMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/inventarisatie/onderwerpen.vue?macro=true";
import { default as end2rIgbBdsTj_07p7YJfWBu98B8mIYePfWhyK7njADbHAMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/end.vue?macro=true";
import { default as index9yHqYI_45gtpeO6Y9X8g0ErqOSr1l_45yiCGUpq7ECHXYjQMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/index.vue?macro=true";
import { default as _91questionKey_93I1tB3B_7IgzsLWlMfNnWVRyvxkR6UYlMmGjF3kHNKIgMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/[questionKey].vue?macro=true";
import { default as inventarisatie7BEYiyHXThiiAluFAv0q0VjNf4C_45ShBNwEQkyaA9duQMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/inventarisatie.vue?macro=true";
import { default as indexRBetVV8sosqSYL_45a_Yit7fw1Vl95AM2W2X34hdHSvH4Meta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/index.vue?macro=true";
import { default as editXr158T3SC47BtgS6VB5FYlyH9tam4uiP1omPlG5LnhcMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/edit.vue?macro=true";
import { default as indexglEnNYy6eqqITI7DBa_kfLeO9f2Fvpx1bw_45IEL2cfTIMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/index.vue?macro=true";
import { default as plan_45van_45aanpakMQioagCp0OocVlUK6alK19TjzPbGd_45keWx2B1QhFEYcMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak.vue?macro=true";
import { default as indext0k8u3AaMOdQC1krRQSAUI_45VdYFQ6MRGZ29Cn6l_45tOAMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/stigas/werknemersvragenlijst/index.vue?macro=true";
import { default as _91rieId_93IhiuO5U4FUGTrwvWdTsdmKuo3SmSWYDEJ23jXu__45EuEMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId].vue?macro=true";
import { default as indexmHqN5t0kUIpFTRd4OxA2hTfYaWr86Kn_45m3OPWK3AgGsMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/gebruikers/index.vue?macro=true";
import { default as _91userId_93UPBuQCa7yIiQJVbh3UXvg0UhMM1pDcvejJIKc76DwwUMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/gebruikers/[userId].vue?macro=true";
import { default as uitnodigenJL6fgafotYsWZO_wre_bd_Y_bo82m9cI193FMMVWtPcMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/gebruikers/uitnodigen.vue?macro=true";
import { default as gebruikersO58IwVZldeJ5KhtebCcTOEEtou4bCJ3Qtl_45jOD0pGD0Meta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/gebruikers.vue?macro=true";
import { default as editYH7AETyAu_45dWnVq95k3W4D6sUQ9iQxb_45TO94a4WLCkAMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/bedrijfsinformatie/edit.vue?macro=true";
import { default as indexSRRxO7V_wwoslJ89QGPJV1zLl0KlXkHEck46rBehG5MMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/bedrijfsinformatie/index.vue?macro=true";
import { default as bedrijfsinformatieLfeimVFUFzFrLVQRkpgq3MlEuOALaAHQhBstb94NdKcMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/bedrijfsinformatie.vue?macro=true";
import { default as _91id_93JJEtggZxF5Ww0UfbkqHgkOJgxwF8vnvXN8kfUWTJH44Meta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/verantwoordelijken/[id].vue?macro=true";
import { default as indexFOxzSdlu7KEh8J0YbzI4DB5lthKrgfGfUjuXGHPj_45CgMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/verantwoordelijken/index.vue?macro=true";
import { default as verantwoordelijkenLcQTHNLUvAxGeQoDnTXbh3aPjEvN_45zjgmLxvnBvsvioMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/verantwoordelijken.vue?macro=true";
import { default as newA8SF2N6pFldKbssjcS3F8WiraVbXIcNzppWpF47ye0UMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/ongevallenregistratie/new.vue?macro=true";
import { default as indexElPlG6q6XRX_yqtgDJfDn7eTmmIH9TcyocL5ln2LQukMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/ongevallenregistratie/index.vue?macro=true";
import { default as edit_TL3bDdX1Hi_wy4CerUZltbLyP8anqR_45EFzkEisnsJ8Meta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/edit.vue?macro=true";
import { default as indexNz19_45S_FAGUr_dXnrCqRuW8jzNU90Cqhs2IuubpdCaEMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/index.vue?macro=true";
import { default as _91accidentId_938XcYezMvdxNZyn5zUtQ5goS_45RfrjUENJ_45HYpY0nboZcMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/ongevallenregistratie/[accidentId].vue?macro=true";
import { default as achtergrondinformatieEdci7VEYnWzGJx_hFJADrtGq9x_455NsUTtmgK5K4e8_45UMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/ongevallenregistratie/achtergrondinformatie.vue?macro=true";
import { default as ongevallenregistratieMR_CVI5GlkrclDvYDKSDCHKBeC1jkK7Xrr6tkRp2LQUMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/ongevallenregistratie.vue?macro=true";
import { default as _91companyId_93bvCo_WDBGxUYboYAkImSBcwJn8RezCOT5fPbm9_45PttcMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId].vue?macro=true";
import { default as newVVQMYQ1srgUAJB4Bg289nloZb54qUgyWoBBx_8n69MgMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/companies/new.vue?macro=true";
import { default as indexc2SkCbX5RccAgnr_uiTKmVJvJwAXqMXfl__45_45P_c1VsoMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/companies/index.vue?macro=true";
import { default as edit2FCd31CstyI6k6pJwJuew3hG65Y2Z5uQf9drfcAi9CAMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/persoonsgegevens/edit.vue?macro=true";
import { default as indexVyPY9pBK9V_9fSjOnr8TtnVXk3OOV0CJzhM_nE_45SGCAMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/persoonsgegevens/index.vue?macro=true";
import { default as persoonsgegevensb_45G6j1As70cTOxIMBKT_i4Tng6q1cROjNGSsLHmfa_cMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/persoonsgegevens.vue?macro=true";
import { default as vragenlijstmHyBcGYf48D4iILmokdLHS77rM6wmGvWPv2LL79F_tEMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/stigas/vragenlijst.vue?macro=true";
import { default as voorwaarden_45afgewezenOrsFrdpROGrRRWuSKvvY6ftXjdy4RqzZaP0maU_459XlkMeta } from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/voorwaarden-afgewezen.vue?macro=true";
export default [
  {
    name: helprn3z3SpRcbkEAea_bnNqdzazSWHgF26M3jil37Eh8BsMeta?.name ?? "help",
    path: "/help",
    meta: helprn3z3SpRcbkEAea_bnNqdzazSWHgF26M3jil37Eh8BsMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/help.vue")
  },
  {
    name: indexiDxrfDBubh7S_CpvTSv_Y84REN5A_45wqyGsum5CQFN0YMeta?.name ?? "index",
    path: "/",
    meta: indexiDxrfDBubh7S_CpvTSv_Y84REN5A_45wqyGsum5CQFN0YMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/index.vue")
  },
  {
    name: loginAIueSh5IVgGjB_g2VXbod12bYbcJVZEjiHkT9xD6VXAMeta?.name ?? "login",
    path: "/login",
    meta: loginAIueSh5IVgGjB_g2VXbod12bYbcJVZEjiHkT9xD6VXAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/login.vue")
  },
  {
    name: logoutCxtyylqAG68mGzmya_Hs7uqCg_45PRQxPE5QPd40LJzZoMeta?.name ?? "logout",
    path: "/logout",
    meta: logoutCxtyylqAG68mGzmya_Hs7uqCg_45PRQxPE5QPd40LJzZoMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/logout.vue")
  },
  {
    name: privacyTOJW22v_5ckQtznJLBmTx1ZSB_45kZYrrgZ2bqFtd_45EIEMeta?.name ?? "privacy",
    path: "/privacy",
    meta: privacyTOJW22v_5ckQtznJLBmTx1ZSB_45kZYrrgZ2bqFtd_45EIEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/privacy.vue")
  },
  {
    name: _91companyId_93bvCo_WDBGxUYboYAkImSBcwJn8RezCOT5fPbm9_45PttcMeta?.name,
    path: "/:companyId()",
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId].vue"),
    children: [
  {
    name: rie4ecEzs_45HKgNoZM3k_451Y13BG4lPqJIfs9O1LPveTAYTAMeta?.name,
    path: "rie",
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/rie.vue"),
    children: [
  {
    name: new_1MHALVTqL4MR8IJllkPo1be8PFbbpK71E3NQ0hC6eoMeta?.name ?? "companyId-rie-new",
    path: "new",
    meta: new_1MHALVTqL4MR8IJllkPo1be8PFbbpK71E3NQ0hC6eoMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/rie/new.vue")
  },
  {
    name: indexpqhPHYw13Qj8keZprWFTK96uU8Y_45WHcd_xWcUW5eiJkMeta?.name ?? "companyId-rie",
    path: "",
    meta: indexpqhPHYw13Qj8keZprWFTK96uU8Y_45WHcd_xWcUW5eiJkMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/rie/index.vue")
  },
  {
    name: editxpcnwLkUnrjIB_qPHoUbj42L7VA47s4r5rTGOhbaFA8Meta?.name ?? "companyId-rie-rieId-edit",
    path: ":rieId()/edit",
    meta: editxpcnwLkUnrjIB_qPHoUbj42L7VA47s4r5rTGOhbaFA8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/rie/[rieId]/edit.vue")
  },
  {
    name: indexTBPTr_45COJXGrMABxml82r2v74P7J_45S_JZ53T82EvLrQMeta?.name ?? "companyId-rie-rieId",
    path: ":rieId()",
    meta: indexTBPTr_45COJXGrMABxml82r2v74P7J_45S_JZ53T82EvLrQMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/rie/[rieId]/index.vue")
  }
]
  },
  {
    name: indexw_45Yg1LKlVKTsORS6wtkFcl0U__xgcdceGxGb1Dndi34Meta?.name ?? "companyId",
    path: "",
    meta: indexw_45Yg1LKlVKTsORS6wtkFcl0U__xgcdceGxGb1Dndi34Meta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/index.vue")
  },
  {
    name: "companyId-rieId",
    path: ":rieId()",
    meta: _91rieId_93IhiuO5U4FUGTrwvWdTsdmKuo3SmSWYDEJ23jXu__45EuEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId].vue"),
    children: [
  {
    name: risicosEL_457zOr6xPCdoXM7veXqN5euWpjJiHGlIBCBHyAbwyAMeta?.name,
    path: "risicos",
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/risicos.vue"),
    children: [
  {
    name: indexIF_3MAnwThpGfvfrBmnjR0kzFIDCHR71AqHPNOQ68ZYMeta?.name ?? "companyId-rieId-risicos",
    path: "",
    meta: indexIF_3MAnwThpGfvfrBmnjR0kzFIDCHR71AqHPNOQ68ZYMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/risicos/index.vue")
  },
  {
    name: edit_YocqPlLHxcOg_45GjKoYdXs5fls95ci53_45GB0jo_45rkKIMeta?.name ?? "companyId-rieId-risicos-riskId-edit",
    path: ":riskId()/edit",
    meta: edit_YocqPlLHxcOg_45GjKoYdXs5fls95ci53_45GB0jo_45rkKIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/edit.vue")
  },
  {
    name: indexzVaHB_6SAxC5KLYI3eRoiCihoQmSbHb6THh_75kKTJcMeta?.name ?? "companyId-rieId-risicos-riskId",
    path: ":riskId()",
    meta: indexzVaHB_6SAxC5KLYI3eRoiCihoQmSbHb6THh_75kKTJcMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/index.vue")
  }
]
  },
  {
    name: dashboardFCyYS_35qbCGzHN7cDMpKUd8qIxS8lLucXuOPLn5UskMeta?.name ?? "companyId-rieId-dashboard",
    path: "dashboard",
    meta: dashboardFCyYS_35qbCGzHN7cDMpKUd8qIxS8lLucXuOPLn5UskMeta || {},
    alias: ["","dashboard"],
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/dashboard.vue")
  },
  {
    name: rapportageahH2Ara1Tx14TxcHn45aWWI71RlCrDhqKECr4tMJvhUMeta?.name,
    path: "rapportage",
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/rapportage.vue"),
    children: [
  {
    name: indexqthD6h0GP4_l6efjzQwoRUsGm9rwoKsyHr63jmwwedoMeta?.name ?? "companyId-rieId-rapportage",
    path: "",
    meta: indexqthD6h0GP4_l6efjzQwoRUsGm9rwoKsyHr63jmwwedoMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/rapportage/index.vue")
  },
  {
    name: aanmakenHnhnxkUUcPpcWwOv0svE4rS4FlHVuCFopaVA6qROniMMeta?.name ?? "companyId-rieId-rapportage-aanmaken",
    path: "aanmaken",
    meta: aanmakenHnhnxkUUcPpcWwOv0svE4rS4FlHVuCFopaVA6qROniMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/rapportage/aanmaken.vue")
  }
]
  },
  {
    name: inventarisatie7BEYiyHXThiiAluFAv0q0VjNf4C_45ShBNwEQkyaA9duQMeta?.name,
    path: "inventarisatie",
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/inventarisatie.vue"),
    children: [
  {
    name: indexWow1en__p_45m7P9tjivX3Rtds_45YtU_L2_qYV94HsyLqwMeta?.name ?? "companyId-rieId-inventarisatie",
    path: "",
    meta: indexWow1en__p_45m7P9tjivX3Rtds_45YtU_L2_qYV94HsyLqwMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/inventarisatie/index.vue")
  },
  {
    name: onderwerpen_yMvRRUt9T8YLohPuWRmcvCOcSIsnWAg3gll0HgeAXUMeta?.name ?? "companyId-rieId-inventarisatie-onderwerpen",
    path: "onderwerpen",
    meta: onderwerpen_yMvRRUt9T8YLohPuWRmcvCOcSIsnWAg3gll0HgeAXUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/inventarisatie/onderwerpen.vue")
  },
  {
    name: end2rIgbBdsTj_07p7YJfWBu98B8mIYePfWhyK7njADbHAMeta?.name ?? "companyId-rieId-inventarisatie-topicKey-end",
    path: ":topicKey()/end",
    meta: end2rIgbBdsTj_07p7YJfWBu98B8mIYePfWhyK7njADbHAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/end.vue")
  },
  {
    name: index9yHqYI_45gtpeO6Y9X8g0ErqOSr1l_45yiCGUpq7ECHXYjQMeta?.name ?? "companyId-rieId-inventarisatie-topicKey",
    path: ":topicKey()",
    meta: index9yHqYI_45gtpeO6Y9X8g0ErqOSr1l_45yiCGUpq7ECHXYjQMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/index.vue")
  },
  {
    name: _91questionKey_93I1tB3B_7IgzsLWlMfNnWVRyvxkR6UYlMmGjF3kHNKIgMeta?.name ?? "companyId-rieId-inventarisatie-topicKey-questionKey",
    path: ":topicKey()/:questionKey()",
    meta: _91questionKey_93I1tB3B_7IgzsLWlMfNnWVRyvxkR6UYlMmGjF3kHNKIgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/[questionKey].vue")
  }
]
  },
  {
    name: plan_45van_45aanpakMQioagCp0OocVlUK6alK19TjzPbGd_45keWx2B1QhFEYcMeta?.name,
    path: "plan-van-aanpak",
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak.vue"),
    children: [
  {
    name: indexRBetVV8sosqSYL_45a_Yit7fw1Vl95AM2W2X34hdHSvH4Meta?.name ?? "companyId-rieId-plan-van-aanpak",
    path: "",
    meta: indexRBetVV8sosqSYL_45a_Yit7fw1Vl95AM2W2X34hdHSvH4Meta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/index.vue")
  },
  {
    name: editXr158T3SC47BtgS6VB5FYlyH9tam4uiP1omPlG5LnhcMeta?.name ?? "companyId-rieId-plan-van-aanpak-actionId-edit",
    path: ":actionId()/edit",
    meta: editXr158T3SC47BtgS6VB5FYlyH9tam4uiP1omPlG5LnhcMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/edit.vue")
  },
  {
    name: indexglEnNYy6eqqITI7DBa_kfLeO9f2Fvpx1bw_45IEL2cfTIMeta?.name ?? "companyId-rieId-plan-van-aanpak-actionId",
    path: ":actionId()",
    meta: indexglEnNYy6eqqITI7DBa_kfLeO9f2Fvpx1bw_45IEL2cfTIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/index.vue")
  }
]
  },
  {
    name: indext0k8u3AaMOdQC1krRQSAUI_45VdYFQ6MRGZ29Cn6l_45tOAMeta?.name ?? "companyId-rieId-stigas-werknemersvragenlijst",
    path: "stigas/werknemersvragenlijst",
    meta: indext0k8u3AaMOdQC1krRQSAUI_45VdYFQ6MRGZ29Cn6l_45tOAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/[rieId]/stigas/werknemersvragenlijst/index.vue")
  }
]
  },
  {
    name: gebruikersO58IwVZldeJ5KhtebCcTOEEtou4bCJ3Qtl_45jOD0pGD0Meta?.name,
    path: "gebruikers",
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/gebruikers.vue"),
    children: [
  {
    name: indexmHqN5t0kUIpFTRd4OxA2hTfYaWr86Kn_45m3OPWK3AgGsMeta?.name ?? "companyId-gebruikers",
    path: "",
    meta: indexmHqN5t0kUIpFTRd4OxA2hTfYaWr86Kn_45m3OPWK3AgGsMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/gebruikers/index.vue")
  },
  {
    name: _91userId_93UPBuQCa7yIiQJVbh3UXvg0UhMM1pDcvejJIKc76DwwUMeta?.name ?? "companyId-gebruikers-userId",
    path: ":userId()",
    meta: _91userId_93UPBuQCa7yIiQJVbh3UXvg0UhMM1pDcvejJIKc76DwwUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/gebruikers/[userId].vue")
  },
  {
    name: uitnodigenJL6fgafotYsWZO_wre_bd_Y_bo82m9cI193FMMVWtPcMeta?.name ?? "companyId-gebruikers-uitnodigen",
    path: "uitnodigen",
    meta: uitnodigenJL6fgafotYsWZO_wre_bd_Y_bo82m9cI193FMMVWtPcMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/gebruikers/uitnodigen.vue")
  }
]
  },
  {
    name: bedrijfsinformatieLfeimVFUFzFrLVQRkpgq3MlEuOALaAHQhBstb94NdKcMeta?.name,
    path: "bedrijfsinformatie",
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/bedrijfsinformatie.vue"),
    children: [
  {
    name: editYH7AETyAu_45dWnVq95k3W4D6sUQ9iQxb_45TO94a4WLCkAMeta?.name ?? "companyId-bedrijfsinformatie-edit",
    path: "edit",
    meta: editYH7AETyAu_45dWnVq95k3W4D6sUQ9iQxb_45TO94a4WLCkAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/bedrijfsinformatie/edit.vue")
  },
  {
    name: indexSRRxO7V_wwoslJ89QGPJV1zLl0KlXkHEck46rBehG5MMeta?.name ?? "companyId-bedrijfsinformatie",
    path: "",
    meta: indexSRRxO7V_wwoslJ89QGPJV1zLl0KlXkHEck46rBehG5MMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/bedrijfsinformatie/index.vue")
  }
]
  },
  {
    name: verantwoordelijkenLcQTHNLUvAxGeQoDnTXbh3aPjEvN_45zjgmLxvnBvsvioMeta?.name,
    path: "verantwoordelijken",
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/verantwoordelijken.vue"),
    children: [
  {
    name: _91id_93JJEtggZxF5Ww0UfbkqHgkOJgxwF8vnvXN8kfUWTJH44Meta?.name ?? "companyId-verantwoordelijken-id",
    path: ":id()",
    meta: _91id_93JJEtggZxF5Ww0UfbkqHgkOJgxwF8vnvXN8kfUWTJH44Meta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/verantwoordelijken/[id].vue")
  },
  {
    name: indexFOxzSdlu7KEh8J0YbzI4DB5lthKrgfGfUjuXGHPj_45CgMeta?.name ?? "companyId-verantwoordelijken",
    path: "",
    meta: indexFOxzSdlu7KEh8J0YbzI4DB5lthKrgfGfUjuXGHPj_45CgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/verantwoordelijken/index.vue")
  }
]
  },
  {
    name: ongevallenregistratieMR_CVI5GlkrclDvYDKSDCHKBeC1jkK7Xrr6tkRp2LQUMeta?.name,
    path: "ongevallenregistratie",
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/ongevallenregistratie.vue"),
    children: [
  {
    name: newA8SF2N6pFldKbssjcS3F8WiraVbXIcNzppWpF47ye0UMeta?.name ?? "companyId-ongevallenregistratie-new",
    path: "new",
    meta: newA8SF2N6pFldKbssjcS3F8WiraVbXIcNzppWpF47ye0UMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/ongevallenregistratie/new.vue")
  },
  {
    name: indexElPlG6q6XRX_yqtgDJfDn7eTmmIH9TcyocL5ln2LQukMeta?.name ?? "companyId-ongevallenregistratie",
    path: "",
    meta: indexElPlG6q6XRX_yqtgDJfDn7eTmmIH9TcyocL5ln2LQukMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/ongevallenregistratie/index.vue")
  },
  {
    name: _91accidentId_938XcYezMvdxNZyn5zUtQ5goS_45RfrjUENJ_45HYpY0nboZcMeta?.name,
    path: ":accidentId()",
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/ongevallenregistratie/[accidentId].vue"),
    children: [
  {
    name: edit_TL3bDdX1Hi_wy4CerUZltbLyP8anqR_45EFzkEisnsJ8Meta?.name ?? "companyId-ongevallenregistratie-accidentId-edit",
    path: "edit",
    meta: edit_TL3bDdX1Hi_wy4CerUZltbLyP8anqR_45EFzkEisnsJ8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/edit.vue")
  },
  {
    name: indexNz19_45S_FAGUr_dXnrCqRuW8jzNU90Cqhs2IuubpdCaEMeta?.name ?? "companyId-ongevallenregistratie-accidentId",
    path: "",
    meta: indexNz19_45S_FAGUr_dXnrCqRuW8jzNU90Cqhs2IuubpdCaEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/index.vue")
  }
]
  },
  {
    name: achtergrondinformatieEdci7VEYnWzGJx_hFJADrtGq9x_455NsUTtmgK5K4e8_45UMeta?.name ?? "companyId-ongevallenregistratie-achtergrondinformatie",
    path: "achtergrondinformatie",
    meta: achtergrondinformatieEdci7VEYnWzGJx_hFJADrtGq9x_455NsUTtmgK5K4e8_45UMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/[companyId]/ongevallenregistratie/achtergrondinformatie.vue")
  }
]
  }
]
  },
  {
    name: newVVQMYQ1srgUAJB4Bg289nloZb54qUgyWoBBx_8n69MgMeta?.name ?? "companies-new",
    path: "/companies/new",
    meta: newVVQMYQ1srgUAJB4Bg289nloZb54qUgyWoBBx_8n69MgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/companies/new.vue")
  },
  {
    name: indexc2SkCbX5RccAgnr_uiTKmVJvJwAXqMXfl__45_45P_c1VsoMeta?.name ?? "companies",
    path: "/companies",
    meta: indexc2SkCbX5RccAgnr_uiTKmVJvJwAXqMXfl__45_45P_c1VsoMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/companies/index.vue")
  },
  {
    name: persoonsgegevensb_45G6j1As70cTOxIMBKT_i4Tng6q1cROjNGSsLHmfa_cMeta?.name,
    path: "/persoonsgegevens",
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/persoonsgegevens.vue"),
    children: [
  {
    name: edit2FCd31CstyI6k6pJwJuew3hG65Y2Z5uQf9drfcAi9CAMeta?.name ?? "persoonsgegevens-edit",
    path: "edit",
    meta: edit2FCd31CstyI6k6pJwJuew3hG65Y2Z5uQf9drfcAi9CAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/persoonsgegevens/edit.vue")
  },
  {
    name: indexVyPY9pBK9V_9fSjOnr8TtnVXk3OOV0CJzhM_nE_45SGCAMeta?.name ?? "persoonsgegevens",
    path: "",
    meta: indexVyPY9pBK9V_9fSjOnr8TtnVXk3OOV0CJzhM_nE_45SGCAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/persoonsgegevens/index.vue")
  }
]
  },
  {
    name: vragenlijstmHyBcGYf48D4iILmokdLHS77rM6wmGvWPv2LL79F_tEMeta?.name ?? "stigas-vragenlijst",
    path: "/stigas/vragenlijst",
    meta: vragenlijstmHyBcGYf48D4iILmokdLHS77rM6wmGvWPv2LL79F_tEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/stigas/vragenlijst.vue")
  },
  {
    name: voorwaarden_45afgewezenOrsFrdpROGrRRWuSKvvY6ftXjdy4RqzZaP0maU_459XlkMeta?.name ?? "voorwaarden-afgewezen",
    path: "/voorwaarden-afgewezen",
    meta: voorwaarden_45afgewezenOrsFrdpROGrRRWuSKvvY6ftXjdy4RqzZaP0maU_459XlkMeta || {},
    component: () => import("/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/pages/voorwaarden-afgewezen.vue")
  }
]